/* eslint-disable react/jsx-key */
import React, { Component } from "react";
import SubHeader from "../Components/SubHeader";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import ImageCarousel from "../Components/UrunCarousel";
import Harita from "../Components/Harita";
import PropertyFeatures from "../Components/PropertyFeatures";
import Loader from "../Components/Loader";
import PropTypes from "prop-types"; // PropTypes'ı import et
import ContactPopup from "../Components/Popup";
import { Helmet } from "react-helmet";
import DOMPurify from "dompurify";

import YouTubePlayer from "../Components/YoutubePlayer";

export default class IlanDetay extends Component {
  cleanHTML = (html) => {
    if (!html) return "";
    return html
      .replace(/\\;/g, "")
      .replace(/\\r\\n/g, "<br />")
      .replace(/\\n/g, "<br />")
      .replace(/\\r/g, "<br />");
  };

  truncateHTML = (html, maxLength) => {
    const div = document.createElement("div");
    div.innerHTML = this.cleanHTML(html);

    let text = div.innerText;
    if (text.length > maxLength) {
      text = text.substring(0, maxLength) + "...";
    }

    return DOMPurify.sanitize(text);
  };
  getIlanDetails = (id) => {
    fetch(`${process.env.REACT_APP_API_URL}/api/ilan/getIlan?id=${id}`, {
      method: "GET",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Veri alınamadı.");
        }
        return response.json();
      })
      .then((data) => {
        if (data["m"] == "basarili") {
          this.setState({ data: data["data"][0] });
          this.setState((prevState) => ({
            propertyDetails: {
              ...prevState.propertyDetails,
              cephe: Array.isArray(data["data"][0]["cephe"])
                ? data["data"][0]["cephe"]
                : data["data"][0]["cephe"]
                ? data["data"][0]["cephe"].split(",")
                : [],
              icOzellikler: Array.isArray(data["data"][0]["ic_ozellikler"])
                ? data["data"][0]["ic_ozellikler"]
                : data["data"][0]["ic_ozellikler"]
                ? data["data"][0]["ic_ozellikler"].split(",")
                : [],
              disOzellikler: Array.isArray(data["data"][0]["dis_ozellikler"])
                ? data["data"][0]["dis_ozellikler"]
                : data["data"][0]["dis_ozellikler"]
                ? data["data"][0]["dis_ozellikler"].split(",")
                : [],
              muhit: Array.isArray(data["data"][0]["muhit"])
                ? data["data"][0]["muhit"]
                : data["data"][0]["muhit"]
                ? data["data"][0]["muhit"].split(",")
                : [],
              ulasim: Array.isArray(data["data"][0]["ulasim"])
                ? data["data"][0]["ulasim"]
                : data["data"][0]["ulasim"]
                ? data["data"][0]["ulasim"].split(",")
                : [],
              manzara: Array.isArray(data["data"][0]["manzara"])
                ? data["data"][0]["manzara"]
                : data["data"][0]["manzara"]
                ? data["data"][0]["manzara"].split(",")
                : [],
            },
          }));
        } else {
          window.location.href = "/";
        }
      })
      .catch((err) => {});
  };
  componentDidMount() {
    window.scrollTo(0, 0);
    // Get the current URL
    const url = window.location.href;

    const urlParams = new URLSearchParams(window.location.search);
    const propertyId = urlParams.get("id");

    if (propertyId) {
      this.getIlanDetails(propertyId);
    } else {
      window.location.href = "/ilanlar";
    }
  }

  // carousel() {
  //   let arrayCarousel = (this.state.data.image_carousel || []).map((item) => {
  //     return {
  //       type: "image",
  //       url: `${process.env.REACT_APP_API_URL}/api/files/?filepath=${item}`,
  //     };
  //   });
  //   arrayCarousel.push({ type: "video", url: this.state.data.videoUrl });
  //   this.setState({ carousel: arrayCarousel });
  // }
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      propertyDetails: {
        cephe: [],
        icOzellikler: [],
        disOzellikler: [],
        muhit: [],
        ulasim: [],
        manzara: [],
      },
      isPopupOpen: false,
    };
  }
  render() {
    return (
      <>
        <Helmet>
          <title>{this.state.data?.title || "Rba Gayrimenkul"}</title>
          <meta
            property="og:title"
            content={this.state.data?.title || "Rba Gayrimenkul"}
          />
          <meta
            property="og:description"
            content={
              this.state.data?.aciklama
                ? this.truncateHTML(this.state.data.aciklama, 50)
                : ""
            }
          />
          <meta
            property="og:image"
            content={
              this.state.data?.image_carousel &&
              this.state.data.image_carousel.length > 0
                ? `${process.env.REACT_APP_API_URL}/api/files/?filepath=${this.state.data.image_carousel[0]}`
                : `${process.env.REACT_APP_API_URL}/default-image.jpg`
            } // Varsayılan bir resim ekleyin
          />
          <meta property="og:url" content={window.location.href} />
          <meta property="og:type" content="website" />
          <meta property="og:site_name" content="Rba Gayrimenkul" />

          <meta name="twitter:card" content="summary_large_image" />
          <meta
            name="twitter:title"
            content={this.state.data?.title || "Rba Gayrimenkul"}
          />
          <meta
            name="twitter:description"
            content={
              this.state.data?.aciklama
                ? this.truncateHTML(this.state.data.aciklama, 50)
                : ""
            }
          />
          <meta
            name="twitter:image"
            content={
              this.state.data?.image_carousel &&
              this.state.data.image_carousel.length > 0
                ? `${process.env.REACT_APP_API_URL}/api/files/?filepath=${this.state.data.image_carousel[0]}`
                : `${process.env.REACT_APP_API_URL}/default-image.jpg`
            }
          />
        </Helmet>
        {/* <Helmet>
          <title>{this.state.data.title}</title>
          <meta property="og:title" content={this.state.data.title} />
          <meta
            property="og:description"
            content={() => {
              return this.truncateHTML(this.state.data.aciklama, 50);
            }}
          />
          <meta
            property="og:image"
            content={`${process.env.REACT_APP_API_URL}/api/files/?filepath=${this.state.data.image_carousel[0]}`}
          />
          <meta
            property="og:url"
            content={`${process.env.REACT_APP_API_URL}/api/files/?filepath=${this.state.data.image_carousel[0]}`}
          />
          <meta property="og:type" content="website" />
          <meta property="og:site_name" content="Rba Gayrimenkul" />

          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={this.state.data.title} />
          <meta
            name="twitter:description"
            content={() => {
              return this.truncateHTML(this.state.data.aciklama, 50);
            }}
          />
          <meta
            name="twitter:image"
            content={`${process.env.REACT_APP_API_URL}/api/files/?filepath=${this.state.data.image_carousel[0]}`}
          />
        </Helmet> */}
        <Loader />

        <SubHeader />
        <Header />

        <div className="page-heading header-text">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <span className="breadcrumb">
                  {this.state.data.emlakDurumu}{" "}
                  {this.state.data.emlakAltTipi
                    ? this.state.data.emlakAltTipi
                    : this.state.data.type}
                </span>
                <h3>{this.state.data.title}</h3>
              </div>
            </div>
          </div>
        </div>
        {/* <YouTubePlayer youtubeUrl={this.state.data.videoUrl}></YouTubePlayer> */}

        {/* <div
          className="btn btn-primary"
          onClick={() => {
            console.log(this.state.data.image_carousel);
          }}
        >
          test
        </div> */}
        <div className="single-property section">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="main-image">
                  {/* <img src="assets/images/single-property.jpg" alt="" /> */}
                  <ImageCarousel
                    images={(this.state.data.image_carousel || []).map(
                      (item) => {
                        return `${process.env.REACT_APP_API_URL}/api/files/?filepath=${item}`;
                      }
                    )}
                  />

                  {/* <ImageCarousel
                    // images={[
                    //   "assets/images/single-property.jpg",
                    //   "assets/images/single-property.jpg",
                    // ]}
                    images={this.state.data.image_carousel.map((item) => {
                      return `${process.env.REACT_APP_API_URL}/api/files/?filepath=${item}]}`;
                    })}
                  ></ImageCarousel> */}
                </div>
                <div className="main-content">
                  <span className="category">
                    <strong>
                      {" "}
                      {this.state.data.emlakDurumu}{" "}
                      {this.state.data.emlakAltTipi
                        ? this.state.data.emlakAltTipi
                        : this.state.data.type}
                    </strong>
                  </span>
                  <h4>
                    <strong>{this.state.data.title}</strong>
                  </h4>

                  <p
                    dangerouslySetInnerHTML={{
                      __html: this.cleanHTML(this.state.data.aciklama),
                    }}
                  />
                  {/* <p>
                    <strong>RBA Gayrimenkul</strong> den{" "}
                    <strong>Kurtuluş Mahallesi</strong>nde,
                    <strong>Adliye Binası Karşısı</strong>nda,
                    <strong>Tramvay</strong>, <strong>Dolmuş</strong> ve{" "}
                    <strong>Otobüs Duraklarına</strong> yürüme mesafesinde,{" "}
                    <strong>Odunpazarı</strong> ve <strong>Hamamyolu</strong>na
                    yürüme mesafesinde.
                  </p>
                  <p>
                    <strong>7 katlı binanın 7. katında</strong>, 135 m
                    <sup>2</sup> alan üzerine
                    <strong>3+1</strong> olarak tasarlanmış dairemiz şu an{" "}
                    <strong>avukat bürosu</strong> olarak kullanılmaktadır.
                  </p>
                  <p>
                    Dairemiz <strong>çift cephelidir</strong> (bir odamız
                    aydınlatmaya bakıyor).
                    <strong>Evin içi komple tadilattan geçmiş</strong>, bütün
                    bakımları yapılmış ve yenilenmiştir.{" "}
                    <strong>Kapalı balkon</strong> yeni yapılmış,
                    <strong>mutfak eksiksiz</strong> durumdadır.
                  </p>
                  <p>
                    <strong>Merkezi sistem</strong> ısıtma mevcuttur.
                    <strong>Asansörlü binamız</strong> yatırımlık olarak da
                    kazandırabilir.
                  </p>
                  <p>
                    <strong>
                      Dairemizi görmek için lütfen randevu alınız.
                    </strong>
                  </p> */}
                </div>
              </div>
              <div className="col-lg-4">
                <div className="info-table">
                  <ul>
                    {this.state.data.price ? (
                      <li>
                        <strong>Fiyat</strong> : {this.state.data.price}₺
                      </li>
                    ) : (
                      <></>
                    )}
                    {this.state.data.il ? (
                      <li>
                        <strong>Konum</strong> : {this.state.data.il}{" "}
                        {this.state.data.ilce}
                      </li>
                    ) : (
                      <></>
                    )}
                    {this.state.data.mahalle ? (
                      <li>
                        <strong>Mah</strong> : {this.state.data.mahalle}
                      </li>
                    ) : (
                      <></>
                    )}

                    {this.state.data.typicalFeatures ? (
                      Array.isArray(this.state.data.typicalFeatures) ? (
                        this.state.data.typicalFeatures.map((item, index) => {
                          const parts = item.split(":");
                          return parts.length === 2 ? (
                            <li key={index}>
                              <strong>{parts[0]}</strong> {":"} {parts[1]}
                            </li>
                          ) : null;
                        })
                      ) : (
                        this.state.data.typicalFeatures
                          .split(",")
                          .map((item, index) => {
                            const parts = item.split(":");
                            return parts.length === 2 ? (
                              <li key={index}>
                                <strong>{parts[0]}</strong> {":"} {parts[1]}
                              </li>
                            ) : null;
                          })
                      )
                    ) : (
                      <></>
                    )}

                    {/* <li>
                      <strong>Alan:</strong> 120 m²
                    </li>
                    <li>
                      <strong>Kat:</strong> 5. Kat
                    </li>
                    <li>
                      <strong>Asansör:</strong> Evet
                    </li>
                    <li>
                      <strong>Ödeme Yöntemi:</strong> Banka Havalesi
                    </li>
                    <li>
                      <strong>Mobilya Durumu:</strong> Tam Mobilyalı
                    </li>
                    <li>
                      <strong>Yapım Yılı:</strong> 2018
                    </li>
                    <li>
                      <strong>Isıtma Sistemi:</strong> Merkezi Isıtma
                    </li>
                    <li>
                      <strong>Türü:</strong> Daire
                    </li>
                    <li>
                      <strong>Konum:</strong> Şehir Merkezi
                    </li> */}
                  </ul>
                </div>

                <div className="agent-info-box mt-4">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title mb-2">Emlak Danışmanı</h5>
                      <h6 className="card-subtitle mb-2 mt-2">
                        {this.state.data.isim} {this.state.data.soyisim}
                      </h6>
                      <p className="card-text">
                        <i className="fa fa-briefcase me-2"></i> İş: (222) 222
                        0722
                        <br />
                        <i className="fa fa-mobile-alt me-2"></i> Cep:{" "}
                        {this.state.data.telefon}
                      </p>
                      <button
                        className="btn btn-primary w-100 mb-2"
                        onClick={() => {
                          this.setState({ isPopupOpen: true });
                        }}
                      >
                        <i className="fa fa-message me-2"></i>
                        İletişime Geç
                      </button>

                      {/* Mobilde gösterilecek tuş */}
                      {window.innerWidth <= 768 && (
                        <a
                          href={`tel:${"+90" + this.state.data.telefon}`}
                          className="btn btn-success w-100"
                        >
                          <i className="fa fa-phone me-2"></i>
                          Emlak Danışmanını Ara
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {this.state.data.embedUrl && (
              <div className="mt-5">
                <h4>Konum</h4>
                <p>
                  {this.state.data.il +
                    " " +
                    this.state.data.ilce +
                    " " +
                    this.state.data.mahalle}
                </p>
                <Harita colNumber={8} embed={this.state.data.embedUrl}></Harita>
              </div>
            )}

            {this.state.data.videoUrl != undefined &&
              this.state.data.videoUrl.length > 0 && (
                <div className="mt-5">
                  <h4>İlan Videosu</h4>
                  <div className="row">
                    <div
                      className="col-lg-8"
                      style={{ paddingLeft: 0, paddingRight: 0 }}
                    >
                      <div className="reset-video-margin">
                        <YouTubePlayer
                          youtubeUrl={this.state.data.videoUrl}
                          isIlanDetay={true}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}

            {/* PropertyFeatures bileşenini buraya ekleyin */}
            <div className="col-lg-8">
              <PropertyFeatures propertyDetails={this.state.propertyDetails} />
            </div>

            <div className="accordion col-lg-8" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingOne">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    RBA Emlak hakkında genel bilgi
                  </button>
                </h2>
                <div
                  id="collapseOne"
                  className="accordion-collapse collapse show"
                  aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    RBA Emlak, Eskişehirde faaliyet gösteren ve alım-satım ile
                    kiralama hizmeti sunan bir emlak şirketidir. Şirketimiz,
                    Eskişehirdeki iki şubesi ile geniş bir portföy sunmakta ve
                    müşteri memnuniyetini ön planda tutmaktadır. Profesyonel
                    ekibimizle size en iyi hizmeti sunmayı hedefliyoruz.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingTwo">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                    Hangi bölgelerde hizmet veriyorsunuz?
                  </button>
                </h2>
                <div
                  id="collapseTwo"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    RBA Emlak, Eskişehir merkez ve şubelerimiz aracılığıyla
                    şehrin farklı bölgelerinde hizmet vermektedir. İhtiyacınıza
                    en uygun gayrimenkulü bulmanıza yardımcı olmak için şehrin
                    çeşitli noktalarındaki projelerle aktif olarak çalışıyoruz.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingThree">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                    Emlak alımı ve satımı için hangi belgeler gerekli?
                  </button>
                </h2>
                <div
                  id="collapseThree"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingThree"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    Emlak alım-satımı için genellikle kimlik belgesi, tapu
                    fotokopisi, vergi levhası ve imza sirküleri gibi belgeler
                    gerekmektedir. Her işlemde gerekli belgeler değişebilir, bu
                    yüzden işlemin türüne göre ek belgeler talep edilebilir.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingFour">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFour"
                    aria-expanded="false"
                    aria-controls="collapseFour"
                  >
                    Kiralama sözleşmesinde dikkat edilmesi gerekenler nelerdir?
                  </button>
                </h2>
                <div
                  id="collapseFour"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingFour"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    Kiralama sözleşmesinde tarafların hakları ve sorumlulukları
                    açıkça belirtilmelidir. Kiralama süresi, kira bedeli, ödeme
                    tarihleri ve depozito gibi detaylar mutlaka sözleşmeye dahil
                    edilmelidir. Tarafların onayı alındıktan sonra sözleşme
                    imzalanmalıdır.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="section best-deal">
          <div className="container">
            <div className="row">
              <div className="col-lg-4">
                <div className="section-heading">
                  <h6>| Best Deal</h6>
                  <h2>Find Your Best Deal Right Now!</h2>
                </div>
              </div>
              <div className="col-lg-12">
                <div className="tabs-content">
                  <div className="row">
                    <div className="nav-wrapper ">
                      <ul className="nav nav-tabs" role="tablist">
                        <li className="nav-item" role="presentation">
                          <button
                            className="nav-link active"
                            id="appartment-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#appartment"
                            type="button"
                            role="tab"
                            aria-controls="appartment"
                            aria-selected="true"
                          >
                            Appartment
                          </button>
                        </li>
                        <li className="nav-item" role="presentation">
                          <button
                            className="nav-link"
                            id="villa-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#villa"
                            type="button"
                            role="tab"
                            aria-controls="villa"
                            aria-selected="false"
                          >
                            Villa House
                          </button>
                        </li>
                        <li className="nav-item" role="presentation">
                          <button
                            className="nav-link"
                            id="penthouse-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#penthouse"
                            type="button"
                            role="tab"
                            aria-controls="penthouse"
                            aria-selected="false"
                          >
                            Penthouse
                          </button>
                        </li>
                      </ul>
                    </div>
                    <div className="tab-content" id="myTabContent">
                      <div
                        className="tab-pane fade show active"
                        id="appartment"
                        role="tabpanel"
                        aria-labelledby="appartment-tab"
                      >
                        <div className="row">
                          <div className="col-lg-3">
                            <div className="info-table">
                              <ul>
                                <li>
                                  Total Flat Space <span>540 m2</span>
                                </li>
                                <li>
                                  Floor number <span>3</span>
                                </li>
                                <li>
                                  Number of rooms <span>8</span>
                                </li>
                                <li>
                                  Parking Available <span>Yes</span>
                                </li>
                                <li>
                                  Payment Process <span>Bank</span>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <img src="assets/images/deal-01.jpg" alt="" />
                          </div>
                          <div className="col-lg-3">
                            <h4>All Info About Apartment</h4>
                            <p>
                              Lorem ipsum dolor sit amet, consectetur adipiscing
                              elit, do eiusmod tempor pack incididunt ut labore
                              et dolore magna aliqua quised ipsum suspendisse.{" "}
                              <br />
                              <br />
                              Swag fanny pack lyft blog twee. JOMO ethical
                              copper mug, succulents typewriter shaman DIY
                              kitsch twee taiyaki fixie hella venmo after
                              messenger poutine next level humblebrag swag
                              franzen.
                            </p>
                            <div className="icon-button">
                              <a href="#">
                                <i className="fa fa-calendar"></i> Schedule a
                                visit
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="tab-pane fade"
                        id="villa"
                        role="tabpanel"
                        aria-labelledby="villa-tab"
                      >
                        <div className="row">
                          <div className="col-lg-3">
                            <div className="info-table">
                              <ul>
                                <li>
                                  Total Flat Space <span>250 m2</span>
                                </li>
                                <li>
                                  Floor number <span>26th</span>
                                </li>
                                <li>
                                  Number of rooms <span>5</span>
                                </li>
                                <li>
                                  Parking Available <span>Yes</span>
                                </li>
                                <li>
                                  Payment Process <span>Bank</span>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <img src="assets/images/deal-02.jpg" alt="" />
                          </div>
                          <div className="col-lg-3">
                            <h4>Detail Info About New Villa</h4>
                            <p>
                              Lorem ipsum dolor sit amet, consectetur adipiscing
                              elit, do eiusmod tempor pack incididunt ut labore
                              et dolore magna aliqua quised ipsum suspendisse.{" "}
                              <br />
                              <br />
                              Swag fanny pack lyft blog twee. JOMO ethical
                              copper mug, succulents typewriter shaman DIY
                              kitsch twee taiyaki fixie hella venmo after
                              messenger poutine next level humblebrag swag
                              franzen.
                            </p>
                            <div className="icon-button">
                              <a href="#">
                                <i className="fa fa-calendar"></i> Schedule a
                                visit
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="tab-pane fade"
                        id="penthouse"
                        role="tabpanel"
                        aria-labelledby="penthouse-tab"
                      >
                        <div className="row">
                          <div className="col-lg-3">
                            <div className="info-table">
                              <ul>
                                <li>
                                  Total Flat Space <span>320 m2</span>
                                </li>
                                <li>
                                  Floor number <span>34th</span>
                                </li>
                                <li>
                                  Number of rooms <span>6</span>
                                </li>
                                <li>
                                  Parking Available <span>Yes</span>
                                </li>
                                <li>
                                  Payment Process <span>Bank</span>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <img src="assets/images/deal-03.jpg" alt="" />
                          </div>
                          <div className="col-lg-3">
                            <h4>Extra Info About Penthouse</h4>
                            <p>
                              Lorem ipsum dolor sit amet, consectetur adipiscing
                              elit, do eiusmod tempor pack incididunt ut Kinfolk
                              tonx seitan crucifix 3 wolf moon bicycle rights
                              keffiyeh snackwave wolf same vice, chillwave
                              vexillologistlabore et dolore magna aliqua quised
                              ipsum suspendisse. <br />
                              <br />
                              Swag fanny pack lyft blog twee. JOMO ethical
                              copper mug, succulents typewriter shaman DIY
                              kitsch twee taiyaki fixie hella venmo after
                              messenger poutine next level humblebrag swag
                              franzen.
                            </p>
                            <div className="icon-button">
                              <a href="#">
                                <i className="fa fa-calendar"></i> Schedule a
                                visit
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        <Footer />
        <ContactPopup
          isOpen={this.state.isPopupOpen}
          onClose={() => {
            this.setState({ isPopupOpen: false });
          }}
          messageTo={this.state.data.id_users}
        />
        <script src="vendor/jquery/jquery.min.js"></script>
        <script src="vendor/bootstrap/js/bootstrap.min.js"></script>
        <script src="assets/js/isotope.min.js"></script>
        <script src="assets/js/owl-carousel.js"></script>
        <script src="assets/js/counter.js"></script>
        <script src="assets/js/custom.js"></script>
      </>
    );
  }
}
